import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { EditorsPostProps } from '@/components/(blog)/post/PostEditorsChoice';
import ArrowLeftSLineIcon from 'remixicon-react/ArrowLeftSLineIcon';
export const RelatedPostsCard: React.FC<EditorsPostProps> = ({
    slug,
    title,
    featuredImage,
    aside,
    sizes,
    responsiveAside,
}) => {
    // responsiveAside: the sidebar row on desktop, a card in the horizontal list on phones (one
    // list for both, instead of two copies in the HTML with one always hidden)
    const asideLg = aside || responsiveAside;
    return (
        <Link
            href={slug}
            prefetch={false}
            rel='noopener noreferrer'
            className={`h-full flex items-start flex-wrap relative pb-2 overflow-hidden transition-all hover:bg-primary/10 dark:hover:bg-white/10 group ${aside ? 'lg:grid lg:grid-cols-12 overflow-visible' : responsiveAside ? 'lg:grid lg:grid-cols-12 lg:overflow-visible' : ''}`}
        >
            {featuredImage && (
                <Image
                    src={featuredImage.node.sourceUrl || ''}
                    width={1300}
                    height={400}
                    // Real display size: without it a 1300-3840px file was fetched for a ~110px
                    // sidebar thumbnail (ten of them per article).
                    sizes={
                        sizes ||
                        (responsiveAside
                            ? '(min-width: 1024px) 120px, 256px'
                            : asideLg
                              ? '(min-width: 1024px) 120px, 100vw'
                              : '(min-width: 1024px) 360px, 100vw')
                    }
                    title={
                        featuredImage.node.title
                            ? featuredImage.node.title
                            : title || 'related_image_alt'
                    }
                    alt={featuredImage.node.altText || title || 'related_image_alt'}
                    className={`col-span-3 w-full aspect-video object-cover ${aside ? '!rounded-md' : responsiveAside ? 'lg:!rounded-md' : ''}`}
                />
            )}
            <p
                className={`col-span-9 w-full text-xs leading-5 font-light text-wrap line-clamp-2 px-2 ${aside ? '' : responsiveAside ? 'max-lg:pe-8' : 'pe-8'} pt-2`}
            >
                {title}
            </p>
            <div
                className={
                    'flex items-end justify-center text-center text-white text-xs absolute left-0 bottom-0'
                }
            >
                <ArrowLeftSLineIcon
                    size={22}
                    className={`${aside ? 'hidden' : responsiveAside ? 'lg:hidden' : ''} dark:bg-progress bg-progress/90 rounded-tr-lg group-hover:brightness-125 transition-all duration-200`}
                />
            </div>
        </Link>
    );
};
